/* Armando's face on the search dropdown's suggestion column.

   The suggestion column is a list of queries the app generated. Unowned, it
   reads as a dumb autocomplete; with a header it reads as Armando offering
   them. The same column also gains a last row that hands whatever is typed
   straight to the chat, so a shopper who does not see what they want has
   somewhere to go other than pressing enter and hoping.

   The app rebuilds that column on every keystroke, so nothing here is inserted
   once: it is re-asserted on mutation and keyed on the text so repeated passes
   are no-ops. */
(function () {
  /* The copy comes from the section's settings, but a theme serving an older
     atomz_header, or a page that does not render it at all, would otherwise
     lose Armando from the dropdown entirely. The defaults are the same strings
     the schema ships, so a missing mount costs the merchant the ability to
     edit them and nothing else. */
  var FALLBACK = {
    title: 'Armando sugiere',
    note: 'Búsquedas que pueden servirte.',
    askLabel: 'Preguntarle a Armando',
    emoji: '🧱'
  };

  function config() {
    var host = document.querySelector('[data-az-suggest]');
    if (!host) return FALLBACK;
    return {
      title: host.dataset.suggestTitle || FALLBACK.title,
      note: host.dataset.suggestNote || FALLBACK.note,
      askLabel: host.dataset.suggestAsk || FALLBACK.askLabel,
      emoji: host.dataset.suggestEmoji || FALLBACK.emoji
    };
  }

  function openChat(text) {
    var chat = window.AtomzChat;
    if (!chat || typeof chat.open !== 'function') return false;
    chat.open();
    if (!text) return true;
    if (typeof chat.send === 'function') {
      chat.send(text);
      return true;
    }
    /* No send() on this build, so the panel's own form carries it. */
    requestAnimationFrame(function () {
      var form = document.querySelector('.atomz-panel [data-atomz="form"]');
      var input = form && form.querySelector('input');
      if (!form || !input) return;
      input.value = text;
      form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
    return true;
  }

  /* The launcher is the only place Armando's picture exists on the page, so it
     is borrowed rather than configured twice. It mounts late, hence the retry. */
  function fillAvatar(slot, cfg) {
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      var img = document.querySelector(
        '.atomz-launcher img, .atomz-launcher__icon img, .atomz-panel__brand-mark img'
      );
      if (img && img.currentSrc) {
        var clone = new Image();
        clone.src = img.currentSrc;
        clone.alt = '';
        clone.loading = 'lazy';
        slot.textContent = '';
        slot.appendChild(clone);
        slot.classList.add('az-suggest__avatar--photo');
        clearInterval(timer);
      } else if (tries > 20) {
        slot.textContent = cfg.emoji;
        clearInterval(timer);
      }
    }, 150);
  }

  function header(cfg) {
    var el = document.createElement('div');
    el.className = 'az-suggest__head';

    var avatar = document.createElement('span');
    avatar.className = 'az-suggest__avatar';
    avatar.setAttribute('aria-hidden', 'true');
    avatar.textContent = cfg.emoji;
    fillAvatar(avatar, cfg);

    var copy = document.createElement('span');
    copy.className = 'az-suggest__copy';
    var title = document.createElement('strong');
    title.className = 'az-suggest__title';
    title.textContent = cfg.title;
    copy.appendChild(title);
    if (cfg.note) {
      var note = document.createElement('span');
      note.className = 'az-suggest__note';
      note.textContent = cfg.note;
      copy.appendChild(note);
    }

    el.appendChild(avatar);
    el.appendChild(copy);
    return el;
  }

  function askRow(cfg, query) {
    var row = document.createElement('button');
    row.type = 'button';
    row.className = 'az-suggest__ask';
    row.innerHTML = '<span class="az-suggest__ask-icon" aria-hidden="true">💬</span>';
    /* Two lines, not one: the suggestion column is a third of the dropdown, so
       a label with the query inside it ellipsises away the one word that says
       what the row will do. */
    var label = document.createElement('span');
    label.className = 'az-suggest__ask-label';
    var lead = document.createElement('span');
    lead.className = 'az-suggest__ask-lead';
    lead.textContent = cfg.askLabel;
    var said = document.createElement('span');
    said.className = 'az-suggest__ask-query';
    said.textContent = '\u00ab' + query + '\u00bb';
    label.appendChild(lead);
    label.appendChild(said);
    row.appendChild(label);
    row.addEventListener('mousedown', function (e) {
      /* mousedown, not click: the input blurs first and the dropdown closes
         before a click would land. */
      e.preventDefault();
      openChat(query);
    });
    return row;
  }

  /* Only the typed state. The empty-input dropdown already has its own heading
     over the trending list, and a second one under it reads as two voices
     arguing over the same four rows.

     Two markups are in the wild. Some builds emit the prompts as flat siblings
     of the product grid, and those have to be gathered into a column before
     the dropdown can be split in two: a grid built out of row spans hands the
     product column's surplus height back to the prompt rows and pulls them
     apart. Other builds already wrap them, the way the empty-input state
     does, and there the wrapper is simply adopted. Either way the result is
     one element holding the prompts, carrying the class the stylesheet keys
     on. Nodes are moved, never cloned, so the app's own click handlers come
     with them. */
  function column(cfg, list) {
    var first = list.querySelector('.az-predict-prompt');
    if (!first) return null;

    var col;
    if (first.parentNode === list) {
      col = list.querySelector(':scope > .az-suggest__col');
      if (!col) {
        col = document.createElement('div');
        col.className = 'az-suggest__col';
        list.insertBefore(col, first);
      }
      /* Prompts the app appended after the last pass, and on the first pass
         all of them. Order is kept because they are taken from the top. */
      var loose = list.querySelectorAll(':scope > .az-predict-prompt');
      for (var i = 0; i < loose.length; i++) col.appendChild(loose[i]);
    } else {
      col = first.parentNode;
      col.classList.add('az-suggest__col');
    }

    if (!col.querySelector(':scope > .az-suggest__head')) {
      col.insertBefore(header(cfg), col.firstChild);
    }
    return col;
  }

  function decorateList(cfg, list) {
    var col = column(cfg, list);
    if (!col) return;

    /* The query belongs to this dropdown's own bar, not the first one on the
       page: the sticky header can put a second search bar in the document. */
    var form = list.closest('.az-search-bar-form') || document;
    var input = form.querySelector('.az-search-bar-input');
    var query = input ? input.value.trim() : '';
    var existing = col.querySelector(':scope > .az-suggest__ask');

    if (!query) {
      if (existing) existing.remove();
      return;
    }
    /* Moved back to the end when the text is unchanged but a prompt landed
       after it. Only when it is not already last: re-appending a node that is
       already in place still counts as a mutation, and this runs from a
       mutation observer. */
    if (existing && existing.dataset.query === query) {
      if (col.lastChild !== existing) col.appendChild(existing);
      return;
    }
    if (existing) existing.remove();

    var row = askRow(cfg, query);
    row.dataset.query = query;
    col.appendChild(row);
  }

  function decorate() {
    var cfg = config();
    var lists = document.querySelectorAll('.az-predict-search-list');
    for (var i = 0; i < lists.length; i++) decorateList(cfg, lists[i]);
  }

  function start() {
    var timer = null;
    var queue = function () {
      clearTimeout(timer);
      timer = setTimeout(decorate, 40);
    };
    /* The body, not the search bar: the bar is re-rendered by the sticky
       wrapper on some pages, which leaves an observer bound to the bar
       watching a node no longer in the document. */
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('input', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('az-search-bar-input')) queue();
    });
    queue();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
